export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13284.c8db3c7a.jpg";